<h1 mat-dialog-title class="pt-2 text-center"> Ajout de mesures</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <div class="row m-0 ">
            <mat-form-field class="col">
                <input matInput [(ngModel)]="Count" placeholder="Nombre" type="number" required>
            </mat-form-field>
        </div>
        <div class="row m-0">
            <mat-form-field class="col">
                <mat-select placeholder="Type de mesure" [(ngModel)]="SelectedType">
                    @for (ex of ExoticTypeList; track ex; let i = $index) {
                    <mat-option [value]="i">
                        {{ ex }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="row m-1">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()">
                Ajouter
            </button>
        </div>
    </div>
</div>